const formatCompletedDate = iso => {
	if (!iso) return ''
	const date = new Date(iso)
	if (Number.isNaN(date.getTime())) return ''
	return date.toLocaleDateString('en-US', {
		month: 'short',
		day: 'numeric',
	})
}

export default function useSessionRow({
	session,
	onResourceClick,
	onAssignmentClick,
	onMarkComplete,
}) {
	const primary = session.status?.primary
	const action = session.status?.action

	const isCompleted = primary === 'done'
	const isCurrent = primary === 'active' || primary === 'next'
	const isUpcoming = primary === 'not_run'
	const isConfigure = action === 'configure'
	const isOpen = action === 'open'
	const isConfigurePrimary = isConfigure && isCurrent
	const isConfigureOutline = isConfigure && !isCurrent
	const completedDateLabel = formatCompletedDate(session.completedAt)

	const handleResourceClick = resourceId => onResourceClick?.(session, resourceId)
	const handleAssignmentClick = () => onAssignmentClick?.(session)
	const handleMarkComplete = () => {
		if (isCompleted) return
		onMarkComplete?.(session)
	}

	return {
		isCompleted,
		isCurrent,
		isUpcoming,
		isConfigure,
		isOpen,
		isConfigurePrimary,
		isConfigureOutline,
		completedDateLabel,
		handleResourceClick,
		handleAssignmentClick,
		handleMarkComplete,
	}
}
